import { GLOBAL_CSS } from "../tokens";

/** Injects the app-wide stylesheet once, at the AppShell level. */
export default function GlobalStyles() {
  return <style>{GLOBAL_CSS}</style>;
}
